"use client";

import { useEffect } from "react";
import { useCookieConsent } from "./CookieConsentProvider";

const TRUSTED_SHOPS_SCRIPT_ID = "gs-consented-trusted-shops";
const TRUSTED_SHOPS_ID = "X453AF47ABC8A6263A22A8E666E7617D8";

declare global {
  interface Window {
    _tsConfig?: Record<string, unknown>;
  }
}

export default function ConsentAwareTrustedShops() {
  const { choice, ready } = useCookieConsent();

  useEffect(() => {
    if (
      !ready ||
      choice !== "all" ||
      document.getElementById(TRUSTED_SHOPS_SCRIPT_ID)
    ) {
      return;
    }

    window._tsConfig = {
      yOffset: "100",
      variant: "reviews",
      customElementId: "trustedShopsCheckout",
      trustcardDirection: "",
      customBadgeWidth: "",
      customBadgeHeight: "",
      disableResponsive: "false",
      disableTrustbadge: "false",
    };

    const script = document.createElement("script");
    script.id = TRUSTED_SHOPS_SCRIPT_ID;
    script.type = "text/javascript";
    script.charset = "utf-8";
    script.async = true;
    script.src = `https://widgets.trustedshops.com/js/${TRUSTED_SHOPS_ID}.js`;
    document.head.appendChild(script);
  }, [choice, ready]);

  return null;
}
